import React from "react"
import "./style.css"
import MainAreaSection from "../MainAreaSection"
import useLang from "../../hooks/useLang"

const BlogMainArea = ({ title, description }) => {

  const blogsTitle = useLang() === "ar" ? "مقالات" : "Blog"
  const safePathBanned = title || ""

  const finalPath = safePathBanned
  ? `${blogsTitle}/${safePathBanned}`
  : blogsTitle

  return <MainAreaSection
    img={require("../../images/product-banner-hero-5.png")}
    title={""} // keep empty
    currentPage={title}
  >
  <div className="heading-text"></div>
  </MainAreaSection>
}
export default BlogMainArea
